import { client } from '../util/createRestApiClient';

export default () => ({
  loginService: (params) => client.request({
    method: 'POST',
    url: 'UserActiveDirectory/login',
    data: params
  }),
  loginAzureService: (params) => client.request({
    method: 'POST',
    url: 'UserActiveDirectory/LoginAzure',
    data: { deviceId: params.deviceId, username: params.username },
    headers: {
      Check: params.password
    }
  }),
  twoFactorService: (params) => client.request({
    method: 'POST',
    url: 'UserActiveDirectory/ValidateTwoFA',
    data: params
  }),
  twoFactorAuthReset: (params) => client.request({
    method: 'POST',
    url: '2FA/ResetUser2FA',
    data: params
  }),
  refreshTokenService: (params) => client.request({
    method: 'POST',
    url: 'UserActiveDirectory/RefreshToken',
    data: params
  })
}
);
